import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { fetchData } from "../../../api/cancuiApi";


const getTagAnalysisDates = async (id) => {
    const equipment = id;
    console.log("Fetching analysis dates for equipment:", equipment);
    const spec = { sensor_id: equipment };


    try {
        const res = await fetchData("getAnalysisDates", spec);
        console.log("Fetched analysis dates:", res);
        return res
    } catch (error) {
        console.error("Error fetching temperature data:", error);
        toast.error("Error fetching temperature data. Please try again later.");
        return {};
    }
}

function useGetTagAnalysisDates(id, resultData) {

    const [data, setData] = useState({});
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {

        async function fetchData() {
            if (id) {
                setIsLoading(true);
                try {
                    // Fetch dew series
                    // const endDate = resultData?.meta?.updated
                    const analysisDates = await getTagAnalysisDates(id);
                    console.log("Analysis Dates fetched in hook:", analysisDates);
                    // analysisDates.end = endDate
                    setData(analysisDates);
                }
                catch (error) {
                    console.error("Error fetching dew series data:", error);
                    toast.error("Error fetching dew series data. Please try again later.");
                } finally {
                    setIsLoading(false);
                }

            }
        }
        fetchData();

    }, [id, resultData]);

    return {
        data,
        isLoading
    };
}
export default useGetTagAnalysisDates;